/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/home/${action[0]}`;

export default class HOME {
  static SUMMARY(params) {
    return http.get(url`summary`, { params });
  }
  static SETTING(data) {
    return http.post(url`setting`, data, formConfig);
  }
  static ENCRYPT(data) {
    return http.post(url`encrypt`, data, formConfig);
  }
  static EXTENSION_SETTING(data) {
    return http.post(url`extensionsetting`, data, formConfig);
  }
  static LDAP_CONNECTION_TEST(data, config) {
    return http.post(url`ldapconnectiontest`, data, {
      ...formConfig,
      ...config
    });
  }
  static NOTICE_SEND_TEST(data, config) {
    return http.post(url`noticesendtest`, data, {
      ...formConfig,
      ...config
    });
  }
}
